import React, { PropTypes as p } from 'react'

import PinMap from './pin-map'
import PinList from './pin-list'

export default React.createClass({
  propTypes: {
    pins: p.array.isRequired,
    mapImageUrl: p.string.isRequired,
    onPinPlace: p.func,
    onPinClick: p.func
  },

  getInitialState () {
    return {
      pinId: null
    }
  },

  render () {
    const {
      pins,
      mapImageUrl,
      onPinPlace,
      onPinClick
    } = this.props

    return (
      <div className='pin-selector'>
        {mapImageUrl &&
          <PinMap
            pins={pins}
            activePinId={this.state.pinId || -1}
            imageUrl={mapImageUrl}
            onPinPlace={onPinPlace}
            onPinClick={onPinClick}
            onPinMouseOver={(pinId) => this.setState({ pinId })}
            onPinMouseOut={() => this.setState({ pinId: null })}
          />
        }
        <PinList
          pins={pins}
          activePinId={this.state.pinId || -1}
          onPinClick={onPinClick}
          onPinMouseOver={(pinId) => this.setState({ pinId })}
          onPinMouseOut={() => this.setState({ pinId: null })}
        />
      </div>
    )
  }
})



// WEBPACK FOOTER //
// ./src/components/pins/pin-selector.js